import { FormValidator, type FormValidatorConfig, type FormValidatorSettings } from '../models';
import { isEmpty } from '../utils';

export interface DateIsBeforeValidatorSettings extends FormValidatorSettings {
  dateToCompare: Date;
  allowEqual: boolean;
}

export type DateIsBeforeValidatorConfig = FormValidatorConfig<DateIsBeforeValidatorSettings>;

export class DateIsBeforeValidator extends FormValidator<DateIsBeforeValidatorSettings> {
  constructor() {
    super();
    this._name = 'dateIsBefore';
    this._settings = {
      invalidMessage: 'form.validator.dateIsBefore.invalidMessage',
      needTranslate: true,
      dateToCompare: new Date(),
      allowEqual: true
    };
  }

  public override async onValidate(value: any) {
    if (isEmpty(value)) {
      this.reset();
      return;
    }

    const dateValue = new Date(value);
    this._valid = this.settings.allowEqual ? dateValue <= this.settings.dateToCompare : value < this.settings.dateToCompare;

    if (!this._valid) {
      this.addMessage(this.settings.invalidMessage, 'error', { dateToCompare: this.settings.dateToCompare.toLocaleDateString() });
    }
  }
}
